/* eslint-disable */
export default {
  mute: 'ミュート',
  unmute: 'ミュート解除',
  hangup: '通話を終了',
  reject: '拒否',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
